export default {
    AuthorizedBookingSpecialist: 'nonrev:web:abs', // NonRevPortal_AuthorizedBookingSpecialist_S
    CoBusinessSelfService: 'nonrev:web:cbss', // NonRevPortal_CoBusinessSelfService_S
    EnhancedAuthorizedBookingSpecialist: 'nonrev:web:eabs', // NonRevPortal_EnhancedAuthorizedBookingSpecialist_S
    GeneralNonrev: 'nonrev:web', // Generic valid non-rev user
    InflightSafetyAuditor: 'nonrev:web:ias', // NonRevPortal_InflightSafetyAuditor_S
    Leisure: 'nonrev:web:mlss', // NRMR_WNA_S | SWA Director & Execs_D
    NRSA: 'nonrev:web:lss', // Nonrev_SpaceAvailable_Listing_D | NonRevPortal_LeisureSelfService_S (depricated)
    NRSASupportRole: 'nonrev:web:lso', // NonRevPortal_LeisureSpaceAvailable_Others_S
    TravelServices: 'nonrev:web:ts' // NonRevPortal_TravelServices_S
};
